// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","258":"ae2fd156","455":"98db480b","977":"9e3561f6"}[chunkId] + ".chunk.js";
};